import React, { useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom"; // Add this import
import {
  HeroSection,
  HeroContent,
  HeroText,
  EyebrowText
} from "./HeroStyles";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
};

export default function Hero() {
  const heroRef = useRef(null);
  const heroControls = useAnimation();
  const heroInView = useInView(heroRef, { once: true });

  React.useEffect(() => {
    if (heroInView) heroControls.start("visible");
  }, [heroInView, heroControls]);

  return (
    <HeroSection id="hero-section" ref={heroRef}>
      <HeroContent>
        <HeroText>
          <motion.div
            initial="hidden"
            animate={heroControls}
            variants={staggerContainer}
          >
            <motion.h1 variants={fadeInUp}>
              Welcome to August Twenty
            </motion.h1>
            <motion.p variants={fadeInUp}>
              Elevate your business with expert insights tailored strategies and unwavering support
            </motion.p>
            <motion.div variants={fadeInUp}>
              {/* Wrap button with Link */}
              <Link to="/contact-us">
                <button>
                  Contact Us
                  <div className="arrow-container">
                    <ArrowUpRight size={20} />
                  </div>
                </button>
              </Link>
            </motion.div>
          </motion.div>
        </HeroText>
      </HeroContent>
    </HeroSection>
  );
}